import React from 'react';
import { Button, Typography, Space } from '@douyinfe/semi-ui';
import { IconClock } from '@douyinfe/semi-icons';
import { useNavigate } from 'react-router-dom';
import './styles/index.scss';

const { Title, Text } = Typography;

interface AccountExpiredPageProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onContactSupport?: () => void;
}

/**
 * 账号过期提示页面组件
 */
const AccountExpiredPage: React.FC<AccountExpiredPageProps> = ({
  title = '账号已过期',
  description = '您的账号已过期，请联系管理员续费后继续使用',
  buttonText = '联系客服',
  onContactSupport,
}) => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    if (onContactSupport) {
      onContactSupport();
    } else {
      // 默认行为：可以跳转到联系页面或显示联系信息
      console.log('请联系客服续费');
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className='account-expired-page'>
      <div className='account-expired-content'>
        <Space vertical spacing={24} align='center'>
          <div className='account-expired-icon'>
            <IconClock size='extra-large' style={{ color: '#ff4d4f' }} />
          </div>

          <div className='account-expired-text'>
            <Title
              heading={4}
              style={{ margin: 0, textAlign: 'center', marginBottom: '10px' }}
            >
              {title}
            </Title>
            <Text className='text-center'>{description}</Text>
          </div>

          <Space spacing={16}>
            <Button
              type='primary'
              theme='solid'
              size='large'
              onClick={handleContactSupport}
              className='contact-support-button'
            >
              {buttonText}
            </Button>
          </Space>
        </Space>
      </div>
    </div>
  );
};

export default AccountExpiredPage;
